export default {"src":"/_next/static/media/PlantingMachine.3e68259a.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};